module.exports = __webpack_public_path__ + "img/logo-light.be6f8daa.png";